import * as types from "./actionTypes";
import moment from 'moment';

const initialState = {
  wsOpened: false,
  gatesData: null,
  updateValidateData: null,
  // switchStatus: window.localStorage.getItem("switchStatus") ? window.localStorage.getItem("switchStatus") : null,
  // switchData: window.localStorage.getItem("switchData") ? window.localStorage.getItem("switchData") : null,
  switchStatus: null,
  switchData: null,
  getUpdateDataTime: null,
  wsDisconnected: false,
};

const pushback = (state = initialState, action) => {
  switch (action.type) {
    case types.WS_CONNECTED:
      console.log("ws connected:", action.host);
      return { ...state, wsOpened: true, wsDisconnected: false, };
    case types.WS_DISCONNECTED:
      console.log("ws disconnected");
      return { ...state, wsOpened: false, gatesData: null, wsDisconnected: true, };
    case types.WS_MESSAGE:
      console.log("update gates data");
      let result = action.payload;
      let gatesdata = null;
      let switchdata = null;
      let updateData = null;
      let getUpdateDataTime = null;
      console.log(result);
      if (result.message_type == "getGatesData") {
        gatesdata = result.data.map(e => {
          e.message_type = result.message_type;
          return e;
        });
        getUpdateDataTime = moment().format('MM/DD/YYYY HH:mm:ss');
      } else if (result.message_type == "readMessage") {
        switchdata = result.data.map(e => {
          e.message_type = result.message_type;
          return e;
        });
        // set status of localstorage
        let status = switchdata[0].status;
        window.localStorage.setItem(
          "switchStatus",
          status
        );

        let data = switchdata;
        window.localStorage.setItem(
          "switchData",
          JSON.stringify(data)
        );

        console.log('switchData reducer', switchdata);


      } else if (result.message_type == "onGateUpdate") {
        let tempGatesData = [...state.gatesData];

        for (let key = 0; key < result.data.length; key++) {
          const element = result.data[key].new_image;

          const index = tempGatesData.findIndex(
            pbdata =>
              pbdata.current_parkingstand === element.current_parkingstand
          );
          // console.log("index", index);
          if (index == -1) {
            tempGatesData = [...tempGatesData, element];
          } else {
            tempGatesData = [
              ...tempGatesData.slice(0, index), // everything before current passenger
              element,
              ...tempGatesData.slice(index + 1) // everything after current passenger
            ];
          }
        }

        getUpdateDataTime = moment().format('MM/DD/YYYY HH:mm:ss');

        gatesdata = tempGatesData.map(e => {
          e.message_type = result.message_type;
          return e;
        });
      } else if (result.message_type == "updateValidateInstruction") {
        let tempGatesData = [...state.gatesData];

        const element = result.data.new_record;
        console.log("uupp element", element);

        const index = tempGatesData.findIndex(
          pbdata => pbdata.current_parkingstand === element.current_parkingstand
        );
        // console.log("index", index);
        if (index == -1) {
          tempGatesData = [...tempGatesData, element];
        } else {
          tempGatesData = [
            ...tempGatesData.slice(0, index), // everything before current passenger
            element,
            ...tempGatesData.slice(index + 1) // everything after current passenger
          ];
        }
        
        getUpdateDataTime = moment().format('MM/DD/YYYY HH:mm:ss');
        updateData = element;
        gatesdata = tempGatesData.map(e => {
          e.message_type = result.message_type;
          return e;
        });
      } else {
        gatesdata = state.gatesData.map(e => {
          e.message_type = result.message_type;
          return e;
        });
      }

      return { 
        ...state, 
        gatesData: gatesdata, 
        switchData: switchdata, 
        updateValidateData: updateData, 
        getUpdateDataTime : getUpdateDataTime,
       
      };

    default:
      return state;
  }
};

export default pushback;
